import React from "react";
import { ReactComponent as Telegram } from "../../svg/telegram.svg";

function footer() {
  return (
    <footer className="footer">
      <span>Разработано</span>
      <div className="footer_row">
        <Telegram className="footer_logo" />
        <a
          href="https://t.me/yogurtwithspoon"
          target="_blank"
          without="true"
          rel="noreferrer"
        >
          @yogurtwithspoon
        </a>
      </div>
    </footer>
  );
}

export default footer;
